import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

import { SKIP_ERROR_TOAST_CONTEXT } from '@/apollo/constants/SkipErrorToastContext';
import { RefreshCurrentUserDocument } from '~/generated/graphql';

// Asks the server to re-read the name and email from the sign-in provider.
// The saved user replaces the cached one (same id), so every screen updates.
// It runs in the background: a failure only leaves the previous name.
export const useRefreshCurrentUser = () => {
  const [refreshCurrentUserMutation] = useMutation(RefreshCurrentUserDocument);

  const refreshCurrentUser = useCallback(async () => {
    const { data, error } = await refreshCurrentUserMutation({
      errorPolicy: 'all',
      context: SKIP_ERROR_TOAST_CONTEXT,
    });

    return { currentUser: data?.refreshCurrentUser ?? null, error };
  }, [refreshCurrentUserMutation]);

  return { refreshCurrentUser };
};
